module.exports = __webpack_public_path__ + "img/desktop-calendar-example.eb4e040d.svg";